<template>
  <el-dialog
    title="Lịch sử hoạt động"
    :visible.sync="isDetailHistoryAction"
    width="1500px"
    :before-close="handleClose"
    top="5vh"
    :close="handleClose"
    custom-class="modern-dialog"
    @open="handleOpen"
    :close-on-click-modal="false"
  >
    <div class="dialog-header-themed">
      <div class="themed-icon"><i class="el-icon-time"></i></div>
      <div class="themed-text">
        <h3>LỊCH SỬ CHI TIẾT HOẠT ĐỘNG CLOUD</h3>
        <p>Theo dõi lịch trình, mốc thời gian thực hiện, kết quả xử lý và dung lượng truyền tải dữ liệu S3.</p>
      </div>
    </div>

    <div class="modern-dialog-form">
      <el-table
        :data="listDetailHistoryAction"
        v-loading="loadingData"
        element-loading-text="Đang tải lịch sử chi tiết..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        :max-height="520"
        :summary-method="getSummaries"
        :show-summary="shouldShowSummary"
      >
        <el-table-column type="index" label="STT" width="55" align="center" />
        
        <el-table-column label="Thời gian thực hiện" align="center">
          <el-table-column width="200" label="Ngày bắt đầu" align="center">
            <template slot-scope="{ row }">
              <span class="date-time-text">{{ formatDate(row.createdDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column width="200" label="Ngày kết thúc" align="center">
            <template slot-scope="{ row }">
              <el-tag v-if="row.lastModifieDate === row.createdDate" size="medium" type="primary" effect="light">Đến nay</el-tag>
              <span v-else class="date-time-text">{{ formatDate(row.lastModifieDate) }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Khoảng thời gian được chọn" align="center">
          <el-table-column width="200" label="Ngày bắt đầu" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.startDate !== null" class="date-time-text">{{ formatDate(row.startDate) }}</span>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column width="200" label="Ngày kết thúc" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.endDate !== null" class="date-time-text">{{ formatDate(row.endDate) }}</span>
              <span v-else>—</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Trạng thái" min-width="200">
          <template slot-scope="{ row }">
            <span class="status-badge-custom" :class="row.delActive ? 'active' : 'inactive'">
              <span class="dot"></span>
              {{ row.statusAction }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Mô tả kết quả" min-width="320">
          <template slot-scope="{ row }">
            <span class="desc-detail">{{ row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Kích thước (MB)" width="150" align="right" v-if="codeAction === 'UPLOADS3'">
          <template slot-scope="{ row }">
            <span class="size-badge">{{ row.sizeFiles ? row.sizeFiles.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination in dialog -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="pageable.page"
          :page-sizes="listSizePage"
          :page-size="pageable.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
        >
        </el-pagination>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer-themed">
        <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
          Đóng lại
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import HistoryActionMaster from "@/services/AdminService/HistoryActionMaster";

export default {
  name: "DetailHistoryActionDialog",
  props: {
    isDetailHistoryAction: {
      type: Boolean,
      default: false
    },
    idHistory: {
      type: Number,
      default: () => 0
    },
    codeAction: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      loadingData: true,
      listDetailHistoryAction: [],
      textTable: "",
      shouldShowSummary: false,
      pageable: {
        page: 1,
        limit: 10
      },
      listSizePage: [10, 30, 40, 50, 100, 200, 500],
      totalRecords: 0
    };
  },
  computed: {
    shouldShowSummaryBasedOnCondition() {
      return this.codeAction === "SCANSERVER" || this.codeAction === "UPLOADS3";
    }
  },
  watch: {
    shouldShowSummaryBasedOnCondition(newVal) {
      this.shouldShowSummary = newVal;
    }
  },
  methods: {
    formatDate(dateTimeString) {
      if (!dateTimeString) return "—";
      const dateTime = new Date(dateTimeString);
      const hours = dateTime.getHours().toString().padStart(2, "0");
      const minutes = dateTime.getMinutes().toString().padStart(2, "0");
      const seconds = dateTime.getSeconds().toString().padStart(2, "0");
      const day = dateTime.getDate().toString().padStart(2, "0");
      const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
      const year = dateTime.getFullYear();

      return `${hours}:${minutes}:${seconds} - ${day}-${month}-${year}`;
    },
    handleOpen() {
      this.loadingData = true;
      HistoryActionMaster.findAllHistoryActionSaveAdminById(
        this.idHistory,
        this.pageable.page,
        this.pageable.limit
      )
        .then((res) => {
          const data = res.data;
          this.listDetailHistoryAction = data.data || [];
          this.totalRecords = data.total || 0;
        })
        .catch((err) => {
          this.listDetailHistoryAction = [];
          console.error(err);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handleClose() {
      this.$emit("close");
      this.pageable.page = 1;
      this.listDetailHistoryAction = [];
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.codeAction === "UPLOADS3") {
        this.shouldShowSummary = true;
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Tổng cộng";
            return;
          }
          if (column.label === "Kích thước (MB)") {
            const values = data.map((item) => parseFloat(item.sizeFiles) || 0);
            const totalSize = values.reduce((prev, curr) => prev + curr, 0);
            sums[index] = totalSize.toFixed(2);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      } else {
        this.shouldShowSummary = false;
      }
    },
    handleSizeChange(value) {
      this.pageable.limit = value;
      this.pageable.page = 1;
      this.handleOpen();
    },
    handleCurrentPageChange(value) {
      this.pageable.page = value;
      this.handleOpen();
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for dialog headers and layouts */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 44px;
  }

  /deep/ td {
    padding: 8px 0;
  }

  /deep/ .el-table__footer-wrapper tbody td.el-table__cell {
    font-weight: bold;
    background-color: #f8fafc;
    color: #1d4ed8;
  }
}

.date-time-text {
  font-family: Consolas, Monaco, monospace;
  font-weight: 600;
  color: #475569;
  font-size: 13px;
}

.desc-detail {
  font-size: 13px;
  color: #1e293b;
  line-height: 1.5;
}

.size-badge {
  font-family: Consolas, Monaco, monospace;
  font-weight: 700;
  color: #2563eb;
  background-color: #eff6ff;
  padding: 3px 8px;
  border-radius: 6px;
}

.status-badge-custom {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.active {
    color: #166534;
    .dot {
      background-color: #22c55e;
    }
  }

  &.inactive {
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}
</style>